import { redirect } from 'react-router-dom';
import { useApplicationStore } from '@data';
import { refetchAndSetPatientProfile } from '@router/loaders/utils';
import { SERVICES_ROUTE_PATHNAME } from '@router/routes/routePathnames';
import { loadServiceTypesByState } from '@router/loaders/utils';

export async function drugScreenLoader(): Promise<Response | null> {
  const { patient, serviceTypes, setServiceTypes, stateCode } =
    useApplicationStore.getState();
  const { patientProfile } = patient;

  if (!patientProfile) {
    try {
      await refetchAndSetPatientProfile();
    } catch {
      // TODO: Handle error https://quick-md.atlassian.net/browse/QMD-1388
      return redirect(SERVICES_ROUTE_PATHNAME);
    }
  }

  if (!serviceTypes.length) {
    try {
      const resolvedStateCode =
        patientProfile?.address?.stateCode || stateCode;

      if (!resolvedStateCode) {
        return redirect(SERVICES_ROUTE_PATHNAME);
      }

      const serviceTypesRes = await loadServiceTypesByState(resolvedStateCode);

      if (!serviceTypesRes) {
        return redirect(SERVICES_ROUTE_PATHNAME);
      }

      setServiceTypes(serviceTypesRes);
    } catch {
      // TODO: Handle error https://quick-md.atlassian.net/browse/QMD-1388
      return redirect(SERVICES_ROUTE_PATHNAME);
    }
  }

  return null;
}
